import { Component, Input } from '@angular/core';
import i18next from 'i18next';

@Component({
  selector: 'app-replaced-data',
  templateUrl: './replaced-data.component.html',
  styleUrls: ['./replaced-data.component.scss']
})
export class ReplacedDataComponent {
  @Input() replacedData?: any;

  emptyData = i18next.t('noData');
}
